module.exports = __webpack_public_path__ + "static/media/financial 1.f811c0c8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/LandingPage/images/new/financial 1.svg
// module id = 3207
// module chunks = 0